
$models.teams = {
	
	getItem : function($teamid, $callback) {
		$models.all.getDataFromAPI('teams/'+$teamid+'.json', '', $callback, 'Unable to retrieve team settings.  You might not have permission to do so.');
	},
	
	getList : function($params, $callback) {
		if ($models.teams.currentGetListAjaxRequest) {
			$models.teams.currentGetListAjaxRequest.abort();
		}
		$models.teams.currentGetListAjaxRequest = $models.all.getDataFromAPI('teams.json', $params, $callback, 'Unable to load the list of teams');
	},
	
	getListWithOffset : function($params, $callback) {
		$params = ($params || {});
		//if (!$params.max_results) {
		//	$params.max_results = $views.foldermanager.maxResultsPerPage;
		//}
		//if ($controllers.foldermanager.currentFoldersListOffset > 0) {
		//	$params['offset'] = $controllers.foldermanager.currentFoldersListOffset;
		//}
		$models.teams.getList($params, $callback);
	},
	
	getSize : function($callback) {
		$models.teams.getList({}, function($data) {
			$callback($data.result_count);
		});
	},
	
	setItem : function($teamid, $name, $callback) {
		$data = {team: {name: $name}};
		if ($teamid > 0) {
			$models.all.getDataFromAPI('teams/'+$teamid+'.json', $data, $callback, 'An error occurred whilst saving changes to the team', 'PUT');
		} else {
			$models.all.getDataFromAPI('teams.json', $data, $callback, 'An error occurred whilst creating the team', 'POST');
		}
	},
	
	deleteItem : function($teamid, $callback) {
		$models.all.getDataFromAPI('teams/'+$teamid+'.json', {}, $callback, 'An error occurred whilst deleting the team', 'DELETE');
	},
	
	getItemPerms : function($callback) {
		$models.all.getDataFromAPI('permissions.json', '', $callback, 'Unable to retrieve list of permissions for this team.');
	},
	
	setItemPerms : function($formData, $callback) {
		$models.all.getDataFromAPI('permissions.json', $formData, $callback, 'An error occurred whilst saving your team permissions', 'PUT', 'generic', 'false', 'application/json');
	},
	
	isAjaxRequestInProgress : function() {
		if (!$models.teams.currentGetListAjaxRequest) { return false; }
		if ($models.teams.currentGetListAjaxRequest.status > 100) { return false; }
		return true;
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/teams.js